import { useEffect, useState } from "react";
import api from "@/lib/api";
import PageHeader from "@/components/PageHeader";
import { Card } from "@/components/ui/card";
import { FileText } from "lucide-react";

export default function Blog() {
  const [items, setItems] = useState([]);
  const [active, setActive] = useState(null);

  useEffect(() => {
    api.get("/blog").then((r) => setItems(r.data.items)).catch(() => {});
  }, []);

  return (
    <>
      <PageHeader title="Blog" subtitle="News, tips and updates" />
      <div className="max-w-xl mx-auto w-full px-4 pb-10 space-y-3">
        {active ? (
          <>
            <button
              onClick={() => setActive(null)}
              className="text-sky-700 text-sm font-semibold hover:underline"
            >
              ← Back to list
            </button>
            <Card className="p-5 border-slate-200">
              <h2 className="font-heading font-black text-2xl text-slate-900 mb-1">{active.title}</h2>
              <div className="text-[10px] font-bold uppercase text-slate-400 tracking-widest mb-3">
                {active.created_at?.slice(0, 10)}
              </div>
              <div className="prose prose-slate max-w-none whitespace-pre-wrap text-slate-700 text-sm leading-relaxed">
                {active.content}
              </div>
            </Card>
          </>
        ) : items.length === 0 ? (
          <Card className="p-8 text-center border-dashed text-slate-500 text-sm">
            No blog posts yet.
          </Card>
        ) : (
          items.map((it) => (
            <button
              key={it.id}
              onClick={() => setActive(it)}
              className="block w-full text-left"
              data-testid={`blog-item-${it.id}`}
            >
              <Card className="p-5 border-slate-200 hover:shadow-md transition-shadow">
                <div className="flex items-start gap-3">
                  <span className="inline-flex h-9 w-9 rounded-xl bg-amber-100 text-amber-800 items-center justify-center shrink-0">
                    <FileText className="h-4 w-4" />
                  </span>
                  <div>
                    <div className="text-[10px] font-bold uppercase text-slate-400 tracking-widest mb-1">
                      {it.created_at?.slice(0, 10)}
                    </div>
                    <h3 className="font-heading font-bold text-slate-900">{it.title}</h3>
                    <p className="text-sm text-slate-600 mt-1 line-clamp-2">
                      {it.excerpt || it.content?.slice(0, 140)}
                    </p>
                  </div>
                </div>
              </Card>
            </button>
          ))
        )}
      </div>
    </>
  );
}
